import { createHelpers } from 'vuex-map-fields';

import { getField, updateField } from 'vuex-map-fields';
import UserService from '../../services/UserService';

export default {
	namespaced: true,
	state: {
		user: {
			email: '',
			password: '',
			passwordConfirmation: '',
			namePrefix: '',
			firstName: '',
			lastNamePrefix: '',
			lastName: '',
		}
	},
	getters: {
		getField,
	},
	actions: {
		async registerUser({ commit, state }) {
			try {
				const payload = await UserService.register(state.user);
				await commit('logInUser', payload, { root: true });
				commit('reset');
			} catch (error) {
				throw error;
			}
		},
	},
	mutations: {
		updateField,
		reset(state) {
			state.user = {
				email: '',
				password: '',
				passwordConfirmation: '',
				namePrefix: '',
				firstName: '',
				lastNamePrefix: '',
				lastName: '',
			};
		}
	}
}
